import React, { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { SidebarContext } from './SidebarContext';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const closeSidebar = () => setSidebarOpen(false);

  const isActive = (path) => location.pathname === path;

  const toggleSidebar = () => setSidebarOpen((open) => !open);

  return (
    <SidebarContext.Provider value={{ toggleSidebar }}>
    <div className="layout-container">
      <style>{`
        .layout-container {
          display: flex;
          height: 100vh;
          max-height: 100vh;
          overflow: hidden;
          background: #F8F9FA;
          font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .sidebar {
          width: 260px;
          min-width: 260px;
          height: 100vh;
          max-height: 100vh;
          background: #1E3A5F;
          color: #ffffff;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          overflow: hidden;
          box-shadow: 4px 0 24px rgba(30, 58, 95, 0.18);
          z-index: 1040;
          transition: transform 0.3s ease;
        }

        .sidebar-brand {
          font-size: 1.25rem;
          font-weight: 700;
          padding: 22px 20px;
          text-align: center;
          background: rgba(0, 0, 0, 0.12);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          letter-spacing: 0.3px;
          flex-shrink: 0;
        }

        .sidebar-brand span {
          display: block;
          font-size: 0.7rem;
          font-weight: 500;
          opacity: 0.75;
          margin-top: 4px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .sidebar-menu {
          list-style: none;
          padding: 12px 0;
          margin: 0;
          flex: 1;
          overflow-y: auto;
          min-height: 0;
        }

        .sidebar-menu li a {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 14px 22px;
          margin: 4px 12px;
          color: rgba(255, 255, 255, 0.85);
          text-decoration: none;
          border-radius: 12px;
          font-weight: 500;
          font-size: 0.95rem;
          transition: all 0.2s ease;
        }

        .sidebar-menu li a .nav-icon {
          font-size: 1.1rem;
          opacity: 0.9;
        }

        .sidebar-menu li a:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #ffffff;
        }

        .sidebar-menu li a.active {
          background: #1A73E8;
          color: #ffffff;
          box-shadow: 0 4px 12px rgba(26, 115, 232, 0.35);
        }

        .sidebar-footer {
          padding: 16px 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.12);
          font-size: 0.75rem;
          opacity: 0.7;
          text-align: center;
          flex-shrink: 0;
        }

        .main-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 100vh;
          max-height: 100vh;
          min-width: 0;
          min-height: 0;
          overflow: hidden;
        }

        .sidebar-overlay {
          display: none;
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1035;
          backdrop-filter: blur(2px);
        }

        .page-content {
          flex: 1;
          min-height: 0;
          overflow-y: auto;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
        }

        @media (max-width: 991px) {
          .sidebar {
            position: fixed;
            top: 0;
            left: 0;
            transform: translateX(-100%);
          }

          .sidebar.open {
            transform: translateX(0);
          }

          .sidebar-overlay.visible {
            display: block;
          }
        }

        @media (max-width: 576px) {
          .sidebar {
            width: 85vw;
            min-width: unset;
            max-width: 300px;
          }
        }
      `}</style>

      <div
        className={`sidebar-overlay ${sidebarOpen ? 'visible' : ''}`}
        onClick={closeSidebar}
      />

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          WhatsApp API
        </div>
        <ul className="sidebar-menu">
          <li>
            <Link to="/" className={isActive('/') ? 'active' : ''} onClick={closeSidebar}>
              <i className="bi bi-phone nav-icon" aria-hidden="true" /> All Devices
            </Link>
          </li>
          <li>
            <Link to="/send-message" className={isActive('/send-message') ? 'active' : ''} onClick={closeSidebar}>   
              <i className="bi bi-send nav-icon" aria-hidden="true" /> Send Message
            </Link>
          </li>
          <li>
            <Link to="/bulk-send" className={isActive('/bulk-send') ? 'active' : ''} onClick={closeSidebar}>
              <i className="bi bi-broadcast nav-icon" aria-hidden="true" /> Bulk Send
            </Link>
          </li>
        
          
        </ul>
        <div className="sidebar-footer">© WhatsApp API Panel</div>
      </div>

      <div className="main-content">
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
    </SidebarContext.Provider>
  );
};

export default Layout;
